import { Router } from "vue-router";

import { useUserStore } from "@/store/user";
import { PUBLIC_RT } from "@/router/white";
import { getUserInfoByPhone } from "@/api/common";

export function tokenPermission(router: Router | undefined) {
  if (router) {
    router.beforeEach(async (to, from, next) => {
      if (PUBLIC_RT.includes(to.name!)) {
        next();
      } else {
        let storeToken = useUserStore();

        if (!storeToken.token) {
          // 没有token，跳转登录页
          next({ name: "Login" });
          return;
        }
        next();
      }
    });
  }
}
